export default __webpack_public_path__ + "static/media/bond.9bb2c50a.svg";